import { Dialog as $ } from './Dialog.js';
import { DialogActions } from './DialogActions.js';
import { DialogContainer } from './DialogContainer.js';
import { DialogContent } from './DialogContent.js';
import { DialogHeader } from './DialogHeader.js';
import { DialogTitle } from './DialogTitle.js';
export * from './Dialog.js';
export * from './DialogHeader.js';
export * from './DialogContainer.js';
export * from './DialogActions.js';
export * from './DialogTitle.js';
export * from './DialogContent.js';

export const Dialog = Object.assign($, {
  Header: DialogHeader,
  Container: DialogContainer,
  Actions: DialogActions,
  Title: DialogTitle,
  Content: DialogContent,
});
